module.exports = __webpack_public_path__ + "img/banner1.8346eb24.png";